import { render, staticRenderFns } from "./LevelInfo.vue?vue&type=template&id=766b0ef4&scoped=true"
import script from "./LevelInfo.vue?vue&type=script&lang=js"
export * from "./LevelInfo.vue?vue&type=script&lang=js"
import style0 from "./LevelInfo.vue?vue&type=style&index=0&id=766b0ef4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766b0ef4",
  null
  
)

export default component.exports